import { IndexedLesson, FacetSearchResponse } from '@lessonup/typescript-core/domain';
import { AnyAction } from '../actions/actions';

export interface LessonSearchState {
  results: FacetSearchResponse<IndexedLesson> | undefined;
  clusterId: string | undefined;
  forLessonId: string | undefined;
}

const initialState: LessonSearchState = {
  results: undefined,
  clusterId: undefined,
  forLessonId: undefined,
};

export function clusterReducer(state: LessonSearchState = initialState, action: AnyAction): LessonSearchState {
  switch (action.type) {
    case 'fetchedClusterResult':
      // eslint-disable-next-line no-case-declarations -- auto-generated TECH-258
      const { clusterId, response, forLessonId } = action;
      return {
        results: response.result,
        clusterId,
        forLessonId,
      };
    default:
      return state;
  }
}
